module.exports = __webpack_public_path__ + "static/3-53b32f3bccda1718468bb9261421f496.jpeg";